module.exports = __webpack_public_path__ + "static/media/GT.e2ff7ec4.svg";